

(function() {
  var root = document.getElementById('loadoutBuilder');
  if (!root) return;

  var STAGE_DISCOUNT_PCT = 5; // 5% per stage
  // Mirrors the Shopify discount codes (percent and minimum subtotal), read from the Admin API 2026-09-24
  // (LOADOUT10 lowered to 219.98 that day, David: the cheapest CARGO plus kit, so "5% per stage" holds).
  // The storefront cannot read discount rules; change these only together with the codes in Shopify.
  var LOADOUT_CODES = [
    { code: 'LOADOUT20', pct: 20, min: 499.96 },
    { code: 'LOADOUT15', pct: 15, min: 399.97 },
    { code: 'LOADOUT10', pct: 10, min: 219.98 }
  ];

  // Product data map for cart (Shopify variant IDs). Prices are NEVER typed here:
  // initLivePrices() reads each variant from /products/{handle}.js.
  var PRODUCTS = {
    cargo_bp:       { vid: 47329910718564, price: null },
    armor_iiia:     { vid: 47096744837220, price: null },
    armor_iii_plus: { vid: 47096942133348, price: null },
    armor_iv:       { vid: 47096751652964, price: null },
    kit_fire:       { vid: 47857335173220, price: null },
    kit_hydration:  { vid: 47857332748388, price: null },
    kit_medical:    { vid: 47857334222948, price: null },
    kit_nav:        { vid: 47857335828580, price: null },
    kit_power:      { vid: 47857333239908, price: null },
    kit_shelter:    { vid: 47857335500900, price: null },
    kit_tools:      { vid: 47857334812772, price: null },
    kit_urban:      { vid: 47857344774244, price: null },
    sentinel_vault: { vid: 47900064219236, price: null }
  };

  // Shopify handle map (keyed by PRODUCTS key) — used by initLivePrices()
  var HANDLES = {
    cargo_bp:       'cargo-tactical-backpack',
    armor_iiia:     'level-iiia-aramid-soft-armor',
    armor_iii_plus: 'level-iii-plus-hard-armor-plate',
    armor_iv:       'level-iv-hard-armor-plate',
    kit_fire:       'fire-and-heat-survival-kit',
    kit_hydration:  'hydration-survival-kit',
    kit_medical:    'medical-and-hygiene-survival-kit',
    kit_nav:        'navigation-awareness-survival-kit',
    kit_power:      'power-and-light-survival-kit',
    kit_shelter:    'shelter-and-sleep-kit',
    kit_tools:      'tools-and-repair-survival-kit',
    kit_urban:      'cargo-urban-survival-loadout',
    sentinel_vault: 'sentinel-vault'
  };

  var state = {
    currentStep: 1,
    totalSteps: 4,
    selections: { cargo_bp: { key: 'cargo_bp', name: 'CARGO 48L Structured Travel Pack', price: null, img: root.querySelector('[data-key="cargo_bp"] .lb__card-img').src } },
    skipped: {}
  };

  var steps = root.querySelectorAll('.lb__step');
  var progressSteps = root.querySelectorAll('.lb__progress-step');
  var summary = root.querySelector('.lb__summary');
  var summaryItems = root.querySelector('.lb__summary-items');
  var tallyBar = root.querySelector('.lb__tally');
  var tallyCount = root.querySelector('.lb__tally-count');
  var tallyPrice = root.querySelector('.lb__tally-price');
  var tallyDiscount = root.querySelector('.lb__tally-discount');

  // Init tally with backpack
  updateTally();
  initLivePrices(); // fetch live prices, refresh display + tally

  // ── Progress step click ──
  root.querySelectorAll('.lb__progress-step').forEach(function(ps) {
    ps.addEventListener('click', function() {
      var step = parseInt(this.dataset.step, 10);
      if (step !== state.currentStep) {
        summary.style.display = 'none';
        goToStep(step);
      }
    });
  });

  // ── Card click ──
  root.querySelectorAll('.lb__card').forEach(function(card) {
    card.addEventListener('click', function(e) {
      var option = this.dataset.option;
      var isMulti = this.classList.contains('lb__card--multi');
      var key = this.dataset.key;

      if (PRODUCTS[key] && PRODUCTS[key].price === null) return; // not priced yet, or unavailable

      if (isMulti) {
        this.classList.toggle('is-selected');
        if (this.classList.contains('is-selected')) {
          state.selections[key] = {
            key: key,
            name: this.querySelector('.lb__card-name').textContent,
            price: PRODUCTS[key].price,
            img: this.querySelector('.lb__card-img').src
          };
        } else {
          delete state.selections[key];
        }
        updateTally();

        return;
      }

      // Single select: deselect others in same option group
      root.querySelectorAll('.lb__card[data-option="' + option + '"]').forEach(function(s) {
        if (s !== card) {
          s.classList.remove('is-selected');
          delete state.selections[s.dataset.key];
        }
      });

      this.classList.toggle('is-selected');
      if (this.classList.contains('is-selected')) {
        state.selections[key] = {
          key: key,
          name: this.querySelector('.lb__card-name').textContent,
          price: PRODUCTS[key].price,
          img: this.querySelector('.lb__card-img').src
        };
      } else {
        delete state.selections[key];
      }

      state.skipped[state.currentStep] = false;
      updateTally();
    });
  });


  // ── Navigation ──
  root.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var action = btn.dataset.action;

    if (action === 'next') {
      if (state.currentStep < state.totalSteps) { goToStep(state.currentStep + 1); }
      else { showSummary(); }
    } else if (action === 'back') {
      if (state.currentStep > 1) { goToStep(state.currentStep - 1); }
    } else if (action === 'restart') {
      summary.style.display = 'none';
      updateTally();
      goToStep(1);
    } else if (action === 'add-to-cart') {
      deployLoadout();
    } else if (action === 'remove') {
      var key = btn.dataset.removeKey;
      if (key && key !== 'cargo_bp') {
        delete state.selections[key];
        // Deselect card
        var card = root.querySelector('[data-key="' + key + '"]');
        if (card) card.classList.remove('is-selected');
        updateTally();
        renderSummary();
      }
    }
  });

  function goToStep(n) {
    state.currentStep = n;
    steps.forEach(function(s) { s.classList.remove('is-visible'); });
    root.querySelector('.lb__step[data-step="' + n + '"]').classList.add('is-visible');
    summary.style.display = 'none';

    progressSteps.forEach(function(ps) {
      var s = parseInt(ps.dataset.step);
      ps.classList.remove('is-active', 'is-done', 'is-skipped');
      if (s === n) ps.classList.add('is-active');
      else if (s < n) ps.classList.add(state.skipped[s] ? 'is-skipped' : 'is-done');
    });

    location.hash = ''; location.hash = 'lb-step-' + n;
  }

  function showSummary() {
    steps.forEach(function(s) { s.classList.remove('is-visible'); });
    progressSteps.forEach(function(ps) {
      var s = parseInt(ps.dataset.step);
      ps.classList.remove('is-active');
      ps.classList.add(state.skipped[s] ? 'is-skipped' : 'is-done');
    });
    summary.style.display = 'block';
    tallyBar.style.display = 'none';
    renderSummary();
    location.hash = ''; location.hash = 'lb-summary';
  }

  function countStages() {
    var hasBackpack = !!state.selections['cargo_bp'];
    var hasArmor = !!state.selections['armor_iiia'] || !!state.selections['armor_iii_plus'] || !!state.selections['armor_iv'];
    var hasKits = false;
    for (var k in state.selections) { if (k.indexOf('kit_') === 0) { hasKits = true; break; } }
    var hasVault = !!state.selections['sentinel_vault'];
    return (hasBackpack ? 1 : 0) + (hasArmor ? 1 : 0) + (hasKits ? 1 : 0) + (hasVault ? 1 : 0);
  }

  function allPriced() {
    for (var k in state.selections) if (state.selections[k].price === null) return false;
    return true;
  }

  function calcDiscount() {
    var stages = countStages();
    var stagePct = stages >= 2 ? stages * STAGE_DISCOUNT_PCT : 0;
    var subtotal = 0;
    for (var k in state.selections) subtotal += state.selections[k].price || 0;
    // Show only the discount the cart will grant: the best code this loadout qualifies for.
    var tier = LOADOUT_CODES.filter(function(t) { return t.pct <= stagePct && subtotal >= t.min; })[0];
    var pct = tier ? tier.pct : 0;
    var code = tier ? tier.code : '';
    var amount = Math.floor(Math.round(subtotal * pct * 100) / 100) / 100; // round down, as the cart does
    return { stages: stages, stagePct: stagePct, pct: pct, subtotal: subtotal, amount: amount, total: subtotal - amount, code: code };
  }

  function updateTally() {
    var keys = Object.keys(state.selections);
    if (keys.length === 0) { tallyBar.style.display = 'none'; return; }
    tallyBar.style.display = 'flex';
    var disc = calcDiscount();
    tallyCount.textContent = keys.length + (keys.length === 1 ? ' item' : ' items');
    tallyPrice.textContent = allPriced() ? '$' + disc.total.toFixed(2) : '...';
    tallyDiscount.textContent = disc.pct > 0 ? '(' + disc.pct + '% off)' : '';
  }

  function renderSummary() {
    var items = [];
    for (var k in state.selections) items.push(state.selections[k]);
    if (items.length === 0) {
      summaryItems.innerHTML = '<div class="lb__summary-empty">No items selected. Go back and build your loadout.</div>';
      root.querySelector('.lb__subtotal-price').textContent = '$0.00';
      root.querySelector('.lb__discount-amount').textContent = '-$0.00';
      root.querySelector('.lb__summary-line--discount').dataset.hidden = 'true';
      root.querySelector('.lb__total-price').textContent = '$0.00';
      root.querySelector('.lb__atc').disabled = true;
      return;
    }
    root.querySelector('.lb__atc').disabled = !allPriced();
    var disc = calcDiscount();

    summaryItems.innerHTML = items.map(function(item) {
      var removeBtn = item.key === 'cargo_bp' ? '' :
        '<button type="button" class="lb__summary-item-remove" data-action="remove" data-remove-key="' + item.key + '">REMOVE</button>';
      return '<div class="lb__summary-item">' +
        '<img src="' + item.img + '" alt="' + item.name + '">' +
        '<div class="lb__summary-item-info">' +
          '<div class="lb__summary-item-name">' + item.name + '</div>' +
        '</div>' +
        '<div class="lb__summary-item-price">' + (item.price === null ? '' : '$' + item.price.toFixed(2)) + '</div>' +
        removeBtn +
      '</div>';
    }).join('');

    root.querySelector('.lb__subtotal-price').textContent = '$' + disc.subtotal.toFixed(2);
    var discountLine = root.querySelector('.lb__summary-line--discount');
    if (disc.amount > 0) {
      discountLine.dataset.hidden = 'false';
      root.querySelector('.lb__discount-label').textContent = disc.stages + ' Stages: ' + disc.pct + '% Off';
      root.querySelector('.lb__discount-amount').textContent = '-$' + disc.amount.toFixed(2);
    } else {
      discountLine.dataset.hidden = 'true';
    }
    root.querySelector('.lb__total-price').textContent = '$' + disc.total.toFixed(2);
  }

  // ── Deploy (Add to Cart) ──
  function deployLoadout() {
    var atcBtn = root.querySelector('.lb__atc');
    var textEl = atcBtn.querySelector('.lb__atc-text');
    var loadEl = atcBtn.querySelector('.lb__atc-loading');
    var arrowEl = atcBtn.querySelector('.lb__atc-arrow');
    atcBtn.disabled = true;
    textEl.style.display = 'none';
    if (arrowEl) arrowEl.style.display = 'none';
    loadEl.style.display = 'flex';

    var disc = calcDiscount();
    var cartItems = [];
    for (var k in state.selections) {
      var sel = state.selections[k];
      var prod = PRODUCTS[k];
      if (prod) {
        cartItems.push({
          id: prod.vid,
          quantity: 1,
          properties: {
            '_loadout': 'CARGO Loadout',
            '_loadout_component': sel.name
          }
        });
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error');
      textEl.textContent = 'ADDED!';
      textEl.style.display = 'inline';
      loadEl.style.display = 'none';
      if (arrowEl) arrowEl.style.display = 'inline';
      atcBtn.disabled = false;

      // Apply discount code and redirect to cart
      if (disc.code) {
        window.location.href = '/discount/' + disc.code + '?redirect=/cart';
      } else {
        var drawer = document.querySelector('[data-cart-drawer]');
        var overlay = document.querySelector('[data-cart-overlay]');
        if (drawer) drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
        if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
        setTimeout(function() { textEl.textContent = 'ADD LOADOUT TO CART'; }, 3000);
      }
    })
    .catch(function(err) {
      console.error('Loadout deploy error:', err);
      textEl.textContent = 'ERROR. TRY AGAIN';
      textEl.style.display = 'inline';
      loadEl.style.display = 'none';
      if (arrowEl) arrowEl.style.display = 'inline';
      atcBtn.disabled = false;
      setTimeout(function() { textEl.textContent = 'ADD LOADOUT TO CART'; }, 2500);
    });
  }

  // Live price loader — fetches from /products/{handle}.js, updates PRODUCTS,
  // DOM card display, and any already-selected state, then re-renders tally
  function initLivePrices() {
    var keys = Object.keys(HANDLES);
    var pending = keys.length;
    function onDone() { if (--pending === 0) { updateTally(); if (summary && summary.style.display !== 'none') renderSummary(); } }
    function markUnavailable(key) {
      var card = root.querySelector('[data-key="' + key + '"]');
      if (!card) return;
      var el = card.querySelector('.lb__card-price strong');
      if (el) el.textContent = 'Price unavailable';
      card.classList.add('is-unavailable');
      card.setAttribute('aria-disabled', 'true');
    }
    keys.forEach(function(key) {
      fetch('/products/' + HANDLES[key] + '.js')
        .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(p) {
          var v = (p.variants || []).filter(function(x) { return x.id === PRODUCTS[key].vid; })[0];
          if (!v) throw new Error('variant ' + PRODUCTS[key].vid + ' not on ' + HANDLES[key]);
          var price = Math.round(v.price) / 100;
          PRODUCTS[key].price = price;
          var card = root.querySelector('[data-key="' + key + '"]');
          if (card) {
            var el = card.querySelector('.lb__card-price strong');
            if (el) el.textContent = '$' + price.toFixed(2);
            var stock = card.querySelector('.lb__stock');
            if (stock) {
              stock.className = 'lb__stock ' + (v.available ? 'lb__stock--in' : 'lb__stock--backorder');
              stock.innerHTML = '<span class="lb__stock-dot"></span> ' + (v.available ? 'In Stock' : 'Sold Out');
            }
          }
          if (state.selections[key]) state.selections[key].price = price;
          onDone();
        })
        .catch(function(err) {
          console.error('Loadout price load failed for ' + key + ':', err);
          markUnavailable(key);
          onDone();
        });
    });
  }

})();

    